// 商户中心下子系统的域名访问

export default JSON.parse(process.env.VUE_APP_SUBSYSTEM_DOMAIN)